import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API_BASE,
    headers: { "Content-Type": "application/json" },
});

export function withAuth(token) {
    return {
        headers: { Authorization: `Bearer ${token}` },
    };
}

// --- Public --- //
export const submitRegistration = (payload) =>
    api.post("/registrations", payload).then((r) => r.data);

export const logAnalytics = (name, props = {}, path) =>
    api
        .post("/analytics/event", {
            name,
            props,
            path: path || (typeof window !== "undefined" ? window.location.pathname : ""),
            session:
                typeof window !== "undefined"
                    ? window.sessionStorage.getItem("sd81_session") || (() => {
                          const s = Math.random().toString(36).slice(2);
                          window.sessionStorage.setItem("sd81_session", s);
                          return s;
                      })()
                    : "",
        })
        .catch(() => {});

export const fetchEventConfig = () =>
    api.get("/event/config").then((r) => r.data);

// --- Admin --- //
export const adminLogin = (email, password) =>
    api.post("/admin/login", { email, password }).then((r) => r.data);

export const adminMe = (token) =>
    api.get("/admin/me", withAuth(token)).then((r) => r.data);

export const listRegistrations = (token, params = {}) =>
    api
        .get("/admin/registrations", { ...withAuth(token), params })
        .then((r) => r.data);

export const updateRegistrationStatus = (token, id, stato) =>
    api.patch(`/admin/registrations/${id}`, { stato }, withAuth(token)).then((r) => r.data);

export const deleteRegistration = (token, id) =>
    api.delete(`/admin/registrations/${id}`, withAuth(token)).then((r) => r.data);

export const adminStats = (token) =>
    api.get("/admin/stats", withAuth(token)).then((r) => r.data);

export const exportUrl = (format) =>
    `${API_BASE}/admin/registrations/export?format=${format}`;
